"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.opsProfileMock = void 0;
exports.opsProfileMock = {
    email: 'user@example.com',
    name: 'John Doe',
    picture: 'https://example.com/picture.jpg',
    id: '1234-5678-91011',
    language: 'en'
};
